import { createContext } from "react";
import { ToastProps } from "../Toast";

type ToastContextType = {
  toastProps: ToastProps | null;
  toggleToast: (toastProps: ToastProps | null) => void;
};

export const ToastContext = createContext<ToastContextType | undefined>(undefined);
